
import React, { useEffect, useState } from 'react'
import Navbar from "./Navbar";
import Footer from "./Footer";
import './Searchengine.css'
import Aos from "aos";
import 'aos/dist/aos.css';
import { fetchseofirstsection, fetchseosecondsection, fetchseothirdsection, base_api } from "./Axios/Axios";
import {Helmet} from "react-helmet";

function Searchengine() {
    const [services, setServices] = useState([]);

            return (
                <div>
                    <Helmet>
        <title>Search Engine Optimization | Phoenix Marketing</title>
        <meta name="description" content="Phoenix Marketing, the leading Online Marketing Company in Madurai, Tamil Nadu, is dedicated to assisting brands and goods in leveraging the power of new media advertising services." />
        <meta name="keywords" content="Phoenix marketing, Madurai Phoenix Marketing Company, Phoenix Marketing Company Madurai, Online Marketing Company Madurai, Digital Marketing, Social Media Marketing Company" />
        <link rel="canonical" href="https://phoenixmarketing.in/search-engine-optimization/" />
      </Helmet>
                    <Navbar />

 <div className='main-content'>
                <div class='social-header-bg-paid'>
                    <div class='row text-contents-service'>
                        <div class='col-lg-8 col-md-12 col-sm-12 offset-lg-0 offset-md-0 offset-sm-0 text-content-service'>
                            <div className="left-content-search">
                                <h1>Search Engine Optimization</h1>
                                <div class='line-service'></div>
                                <h4>SEO in digital marketing is a strategy that focuses on
                                    your website's presence in the search results on search
                                    engines like Google. SEO may target different kinds of
                                    search, including image search, local search, video search,
                                    and news search engines.
                                </h4>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-12 col-sm-12 text-image-search">
                            <img src="/Searchengine/SEO image 1.png" />
                        </div>
                    </div>
                </div>


                <p className='second-paragraph'>PHOENIX, a Search Engine Optimization Company and Google Awards Certified
                    Company based in Madurai, Tamil Nadu, India. Helps your website achieve a higher ranking with the major
                    search engines. Keywords are the words and phrases your target audience searches for online. Search engines
                    want to do their jobs as best as possible by referring users to website and content that is most relevant
                    to what the user is looking for. When you implement an SEO strategy, your improvements will send positive signals
                    to search engines that your website provides value to users. As a result, search engines will rank your website
                    higher in the SERPs.</p>

                <div className='containerpart1'>
                <div className='row firstcontent'>
                    <div className='col-lg-6 col-md-12 col-sm-12'>
                        <div class="image">
                            <img src="/Searchengine/29210263_13 copy 1.png" alt="Image" height="500" width="600" />
                        </div>
                    </div>

                    <div className='col-lg-6 col-md-12 col-sm-12 paragraph'>
                        <div className='upside-content'>
                            <h3>On-Page SEO</h3>
                            <div className='container-upside'>
                                On-page SEO leads to higher search rankings, increased traffic to your
                                site, and more conversions. On-page SEO is multiphased, and extends
                                beyond content into their things like schema and meta tags. The results
                                of on-page SEO take time, but once your on-page SEO strategy gets off the
                                grounds, it can make your online rankings and sales in order.
                            </div>
                        </div>

                        <div className='downside-content'>
                            <h3>Off-Page SEO</h3>
                            <div className='container-downside'>
                                Successfully SEO requires a healthy combination of on-page and off-page
                                SEO in digital marketing. Link building, guest blogging, social media
                                marketing, local citation building, and more are out-off
                            </div>
                        </div>
                    </div>
                </div>
                </div>

<div className='containerpart3'>
<div className='below-content'>

                    <div className='row'>

<div className='col-lg-7 col-md-12 col-sm-12'>
                            <div className='belowsecondcontent'>
                                <h3>Technical SEO</h3>
                                <div class="container-first">
                                    <div className='row'>
                                        <div className='col-lg-2 col-md-12 col-sm-12'>
                                            <div class="image-screw">
                                                <img src="/Searchengine/seo 1.png" alt="Image" height="120" width="120" />
                                            </div>
                                        </div>
                                        <div className='col-lg-10 col-md-12 col-sm-12'>
                                            <div class="content">
                                                <p>Technical SEO is about improving your website to make it easier for search
                                                    engines to find, understand, and store your content. Technical SEO refers to
                                                    the behind the scenes elements that power your organic growth engine, such
                                                    as site architecture, mobile optimization, and page speed. In digital marketing,
                                                    technical SEO can boost your visibility in search results.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h3 className='link-building'>Link Building</h3>
                                <div class="container-second">
                                    <div className='row'>
                                        <div className='col-lg-2'>
                                            <div class="image-lens">
                                                <img src="/Searchengine/Group 33.png" alt="Image" height="120" width="120" />
                                            </div>
                                        </div>
                                        <div className='col-lg-10'>
                                            <div class="content">
                                                <p>Technical SEO is about improving your website to make it easier for search
                                                    engines to find, understand, and store your content. Technical SEO refers to
                                                    the behind the scenes elements that power your organic growth engine, such
                                                    as site architecture, mobile optimization, and page speed. In digital marketing,
                                                    technical SEO can boost your visibility in search results.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-5 col-md-12 col-sm-12'>
                            <div className='image rocket'>
                                <img src="/Searchengine/Group 35.png" width="420" />
                            </div>
                        </div>
                    </div>
        
                    <div className='row'>
                        <div className='col-lg-5 col-md-12 col-sm-12'>
                            <div className='galaxy'>
                                <img src="/Searchengine/Frame 155.png" height="500" width="500" />
                            </div>
                        </div>

<div className='col-lg-7 col-md-12 col-sm-12'>
                            <div className='second-below-para'>
                                <h3>SEO Site Audit</h3>
                                <div class="container-second">
                                    <div className='row'>
                                        <div className='col-lg-2'>
                                            <div class="image-tick">
                                                <img src="/Searchengine/Group 34.png" alt="Image" height="120" width="120" />
                                            </div>
                                        </div>
                                        <div className='col-lg-10'>
                                            <div class="content">
                                                <p>Technical SEO is about improving your website to make it easier for search
                                                    engines to find, understand, and store your content. Technical SEO refers to
                                                    the behind the scenes elements that power your organic growth engine, such
                                                    as site architecture, mobile optimization, and page speed. In digital marketing,
                                                    technical SEO can boost your visibility in search results.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

</div>
</div>

                {/* <ScrollToTop /> */}
                {/* < Footer /> */}

            </div>
                    <Footer />
                </div>
            );
        } 
        

export default Searchengine;
